import { 
    useContext,
    useEffect, 
    useState 
} from 'react';
import { 
    styled, 
    useTheme 
} from '@mui/material/styles';
import { useNavigate } from 'react-router-dom';

import { ContextApi } from '../../context/contextApi';
import { DrawerContext } from '../../context/drawerContext';

import MuiDrawer from '@mui/material/Drawer';
import IconButton from '@mui/material/IconButton';
import Divider from '@mui/material/Divider';
import List from '@mui/material/List';
import ListItem from '@mui/material/ListItem';
import ListItemButton from '@mui/material/ListItemButton';
import ListItemIcon from '@mui/material/ListItemIcon';
import ListItemText from '@mui/material/ListItemText';
import ChevronLeftIcon from '@mui/icons-material/ChevronLeft';
import VideoCallIcon from '@mui/icons-material/VideoCall';
import AddIcon from '@mui/icons-material/Add';
import ShopTwoIcon from '@mui/icons-material/ShopTwo';
import HomeIcon from '@mui/icons-material/Home';
import LowPriorityIcon from '@mui/icons-material/LowPriority';
import FolderSharedIcon from '@mui/icons-material/FolderShared';

import styles from './style.module.scss'

const drawerWidth = 260;

export function DrawerComponent() {
    const { loggedUser, cookies } = useContext(ContextApi)
    const navigate = useNavigate()
    const {
        setShowInnerCamera,
        setShowInnerVideo,
        setShowMenuOrderingEstados,
        setShowMenuOrderingEstadosByRegional
      } = useContext(DrawerContext)
    const [openDrawer, setOpenDrawer] = useState(false);

    const urlParams = window.location.pathname;
    //pegar array urlSemId[1] na posição 1
    const urlSemId = urlParams.split('/')

    
    const openedMixin = (theme) => ({
      width: drawerWidth,
      transition: theme.transitions.create('width', {
        easing: theme.transitions.easing.sharp,
        duration: theme.transitions.duration.enteringScreen,
      }),
      overflowX: 'hidden',
    });
    
  const closedMixin = (theme) => ({
    transition: theme.transitions.create('width', {
      easing: theme.transitions.easing.sharp,
      duration: theme.transitions.duration.leavingScreen,
    }),
    overflowX: 'hidden',
    width: `calc(${theme.spacing(7)} + 1px)`,
    [theme.breakpoints.up('sm')]: {
      width: `calc(${theme.spacing(8)} + 1px)`,
    },
  });
  
  const DrawerHeader = styled('div')(({ theme }) => ({
      display: 'flex',
      alignItems: 'center',
      justifyContent: 'flex-end',
      padding: theme.spacing(0, 1),
      backgroundColor: '#55AAD0',
      // necessary for content to be below app bar
      ...theme.mixins.toolbar,
    }));
  
  const Drawer = styled(MuiDrawer, { shouldForwardProp: (prop) => prop !== 'open' })(
      ({ theme, open }) => ({
        width: drawerWidth,
        flexShrink: 0,
        whiteSpace: 'pre-wrap',
        boxSizing: 'border-box',
        ...(open && {
          ...openedMixin(theme),
          '& .MuiDrawer-paper': openedMixin(theme),
          color: '#FFFFFF',
          }),
          ...(!open && {
            ...closedMixin(theme),
          '& .MuiDrawer-paper': closedMixin(theme),
        }),
      }),
    );
  
  const itensListDrawer = [
      {
        icon: <VideoCallIcon />, 
        label: 'Nova Camera',
        labelSecundary: '',
        handleClick: () => setShowInnerCamera(true),
        status: urlSemId[1] === 'editar-camera' ? false : true
      },
      {
        icon: <HomeIcon />, 
        label: 'Voltar a Home',
        labelSecundary: '',
        handleClick: () => navigate(`/`),
        status: urlSemId[1] === '' ? false : true
      },
      {
        icon: <ShopTwoIcon />, 
        label: 'Novo Anuncio',
        labelSecundary: '',
        handleClick: () => setShowInnerVideo(true),
        status: true
      },
      {
        icon: <LowPriorityIcon />, 
        label: 'Ordenar câmeras',
        labelSecundary: '',
        handleClick: cookies?.surfViewToken?.userRole === "regional" ? () => setShowMenuOrderingEstadosByRegional(true) : () => setShowMenuOrderingEstados(true),
        status: true
      },
      {
        icon: <FolderSharedIcon />, 
        label: 'Cadastro de regionais',
        labelSecundary: '',
        handleClick: () => navigate(`/nova-regional`),
        status: cookies?.surfViewToken?.userRole === "regional" ? false : true
      },
  ]
  
    return (
        <>
        {loggedUser &&
            <Drawer className={styles.drawerContainer} variant="permanent" open={openDrawer}>
              <DrawerHeader>
                <IconButton onClick={() => setOpenDrawer(!openDrawer)}>
                  {!openDrawer ? <AddIcon className={styles.iconOpenAndCloseDrawer}/> : <ChevronLeftIcon className={styles.iconOpenAndCloseDrawer}/>}
                </IconButton>
              </DrawerHeader>
              <Divider />
              <List>
                {itensListDrawer.filter(item => item.status === true).map((item) => (
                  <ListItem key={item.label} disablePadding sx={{ display: 'block' }}>
                    <ListItemButton
                      sx={{
                        minHeight: 48,
                        justifyContent: openDrawer ? 'initial' : 'center',
                        px: 2.5,
                      }}
                      onClick={item.handleClick}
                    >
                      <ListItemIcon
                        sx={{
                          minWidth: 0,
                          mr: openDrawer ? 3 : 'auto',
                          justifyContent: 'center',
                        }}
                      >
                        {item.icon}
                      </ListItemIcon>
                      <ListItemText primary={item.label} secondary={item.labelSecundary} sx={{ opacity: openDrawer ? 1 : 0, display: openDrawer ? 'block' : 'none'}} />
                    </ListItemButton>
                  </ListItem>
                ))}
              </List>
              <Divider />
              <List>
                  <ListItem disablePadding sx={{ display: 'block' }}>
                    <ListItemButton
                      sx={{
                        minHeight: 48,
                        justifyContent: openDrawer ? 'initial' : 'center',
                        px: 2.5,
                      }}
                    >
                      <ListItemIcon
                        sx={{
                          minWidth: 0,
                          mr: openDrawer ? 3 : 'auto',
                          justifyContent: 'center',
                        }}
                      >
                      </ListItemIcon>
                      <ListItemText sx={{ opacity: openDrawer ? 1 : 0 }} />
                    </ListItemButton>
                  </ListItem>
              </List>
            </Drawer>}
        </>
    )
}